import { AppAppConfig } from '@zto/zpage'

export const app: AppAppConfig = {
  portal: {},
  menu: {
    // displayedSubmodules: ['快超']
  }
}
